import React from "react";
import ChartLoader from "./ChartLoader";
import LineChart from "../../ui/charts/LineChart";
import DonutChart from "../../ui/charts/DonutChart";

const Charts = ({
    charts,
    chartsLoading,
    chartData,
}) => {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 my-8">
            {chartsLoading ? (
                <>
                    {charts.map((chart, index) => (
                        <ChartLoader key={index} />
                    ))}
                </>
            ) : (
                <>
                    {charts.map((chart, index) => (
                        <div key={index} className="bg-white rounded-xl shadow-sm">
                            <div className="p-6">
                                <h3 className="text-lg font-semibold mb-1">
                                    {chart.displayName}
                                </h3>
                                <p className="text-sm text-gray-500 mb-4">
                                    {chart.subTitle}
                                </p>
                                <div className="h-80">
                                    {chart.chartType === "line" && (
                                        <LineChart
                                            data={chartData?.[chart.name] || []}
                                            categories={chart.categories}
                                            categoryNames={chart.categoryNames}
                                            index={chart.index}
                                            colors={chart.colors || ["#2F6B79", "#A3E0E9"]}
                                            valueFormatter={
                                                chart.tooltipValueFormatter ||
                                                chart.valueFormatter
                                            }
                                            yAxisValueFormatter={
                                                chart.yAxisValueFormatter ||
                                                ((value) => value)
                                            }
                                            showLegend={true}
                                            showGridLines={true}
                                            yAxisWidth={60}
                                        />
                                    )}
                                    {chart.chartType === "donut" && (
                                        <DonutChart
                                            data={chartData?.jobStatusDistribution || []}
                                            category="count"
                                            index="status"
                                            colors={['blue', 'cyan', 'indigo', 'violet', 'fuchsia']}
                                            valueFormatter={(value) => `${value} jobs`}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};

export default Charts;